import { useState, useEffect } from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X, ScrollText } from "lucide-react";

const paragraphs = [
  "The Holy Scriptures are the inspired and unchanging Word of God—the only true authority for faith, doctrine, and righteous living. We invite every person to search the Scriptures for themselves, allowing God's Word—not religious tradition, culture, or human opinion—to reveal His truth.",
  "As the light of Scripture shines upon our hearts, it exposes error, brings conviction, and calls us to genuine repentance. Those who receive the truth with humility will experience the transforming power of God, leading to renewed life through the Messiah and a restored walk of faithful obedience.",
  "Our mission is to proclaim the restoration of the original Gospel taught by Christ and His apostles. We believe God is calling people from every nation, tribe, and language to return to His righteous ways, to worship Him in spirit and in truth, and to become faithful disciples who live according to His commandments.",
  "We encourage all people to test every teaching by the Scriptures, hold fast to what is true, and walk in the everlasting covenant God has revealed through His Word.",
];

export const Mission = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("open-mission", handler);
    return () => window.removeEventListener("open-mission", handler);
  }, []);

  return (
    <DialogPrimitive.Root open={open} onOpenChange={setOpen}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/90 backdrop-blur-sm data-[state=open]:animate-in data-[state=open]:fade-in-0" />
        <DialogPrimitive.Content
          data-testid="mission-modal"
          className="fixed left-1/2 top-1/2 z-50 w-[92vw] max-w-2xl max-h-[88vh] overflow-y-auto -translate-x-1/2 -translate-y-1/2 border border-[#4A453F] bg-[#0A0A0A] p-8 md:p-12 focus:outline-none data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95"
        >
          <DialogPrimitive.Close
            data-testid="mission-close"
            className="absolute top-5 right-5 text-[#A39E98] hover:text-[#F4F0EA] transition-colors"
          >
            <X strokeWidth={1} className="h-6 w-6" />
          </DialogPrimitive.Close>

          <div className="flex items-center gap-2 mb-4">
            <ScrollText strokeWidth={1.5} className="h-4 w-4 text-[#D4AF37]" />
            <span className="font-mono text-xs tracking-[0.2em] uppercase text-[#D4AF37]">
              Who We Are
            </span>
          </div>
          <DialogPrimitive.Title className="font-heading font-light tracking-tight text-4xl md:text-5xl text-[#F4F0EA] mb-8">
            Our <span className="italic text-[#D4AF37]">Mission</span>
          </DialogPrimitive.Title>

          <DialogPrimitive.Description asChild>
            <div className="space-y-5">
              {paragraphs.map((p, i) => (
                <p key={i} className="text-base md:text-lg leading-relaxed font-light text-[#A39E98]">
                  {p}
                </p>
              ))}
            </div>
          </DialogPrimitive.Description>

          <button
            data-testid="mission-close-cta"
            onClick={() => setOpen(false)}
            className="mt-10 bg-[#D4AF37] text-[#0A0A0A] font-medium px-8 py-3 hover:bg-[#E5C865] transition-colors"
          >
            Amen
          </button>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
};

export const openMission = () => {
  window.dispatchEvent(new Event("open-mission"));
  if (typeof window.gtag === "function") window.gtag("event", "open_mission", { category: "engagement" });
};
